import { render, staticRenderFns } from "./ScreeningEdit.vue?vue&type=template&id=8b8af25e&scoped=true&"
import script from "./ScreeningEdit.vue?vue&type=script&lang=js&"
export * from "./ScreeningEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8af25e",
  null
  
)

export default component.exports